module.exports = __webpack_public_path__ + "static/media/TP_CC (Salingogon).27d780a5.png";